export function validatePhone (valideStr) {
  let reg = /^1\d{10}$/
  return reg.test(valideStr)
}

export function validateIdCard (valideStr) {
  const valideStr2 = valideStr.toUpperCase()
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(valideStr2)) {
    return false
  }
  return true
}

export function parseBirthdayFromIdCard (IdCard) {
  if (!validateIdCard(IdCard)) {
    return ''
  }

  return IdCard.substring(6, 10) + '-' + IdCard.substring(10, 12) + '-' + IdCard.substring(12, 14)
}
